// Copyright © Orpyx® Medical Technologies Inc. 2026. All rights reserved.
// **ORPYX TRADE SECRET**
// **WARNING**: The contents of this repository, including source code and assets, are confidential. This source code and/or derived works are a trade secret of Orpyx Medical Technologies Inc. Unauthorized disclosure is strictly prohibited and may result in serious legal consequences.

import {OperationErrorType, StoreAction} from "orpyx-web-common";
import {IActionRequiredAlertsEntry} from "doctors-dashboard/http-clients/index";
import produce from "immer";
import {PatientInformationActionRequiredAlertsActions} from "./patient-information-action-required-alerts.actions";
import {SelectedActionRequiredAlerts} from "./patient-information-action-required-alerts.types";

export interface PatientInformationActionRequiredAlertsState {
    loading: boolean;
    error: OperationErrorType;

    alerts: IActionRequiredAlertsEntry[] | null;
    selected: SelectedActionRequiredAlerts,
}

const initialState: PatientInformationActionRequiredAlertsState = {
    loading: false,
    error: undefined,

    alerts: null,
    selected: {},
};

const PatientInformationActionRequiredAlertsReducers = (state = initialState, action: StoreAction<PatientInformationActionRequiredAlertsActions>): PatientInformationActionRequiredAlertsState => {
    return produce(state, (draft: PatientInformationActionRequiredAlertsState) => {
        switch (action.type) {
            case PatientInformationActionRequiredAlertsActions.SELECT_ACTION_REQUIRED_ALERT:
                const requiredActionAlertId: number = action.payload!;

                const selected: boolean | undefined = draft.selected[requiredActionAlertId];
                if (selected) {
                    delete draft.selected[requiredActionAlertId];
                } else {
                    draft.selected[requiredActionAlertId] = true;
                }
                break;

            case PatientInformationActionRequiredAlertsActions.RESET_PATIENT_ACTION_REQUIRED_ALERTS:
                draft.loading = false;
                draft.error = undefined;
                draft.selected = {};
                draft.alerts = null;
                break;

            case PatientInformationActionRequiredAlertsActions.GET_PATIENT_ACTION_REQUIRED_ALERTS:
                draft.loading = true;
                draft.error = undefined;
                draft.selected = {};
                draft.alerts = null;
                break;

            case PatientInformationActionRequiredAlertsActions.GET_PATIENT_ACTION_REQUIRED_ALERTS_SUCCESSFULLY:
                draft.error = undefined;
                draft.alerts = action.payload;
                draft.loading = false;
                break;

            case PatientInformationActionRequiredAlertsActions.GET_PATIENT_ACTION_REQUIRED_ALERTS_FAILED:
                draft.error = action.payload;
                draft.loading = false;
                break;
        }
    });
};

export default PatientInformationActionRequiredAlertsReducers;
